<!--  -->
<template>
<cc-container class="skeketon" style="height:100%; overflow:hidden">
 <cc-main style="overflow:hidden" >
   <div class="head">
    <div class="skeketon-center-content"></div>
    </div>
    <div class="skeketon-top">
      <div class="skeketon-top-top"></div>
       <div class="skeketon-top-bottom"></div>
    </div>
    <div class="skeketon-center">
      <div class="skeketon-center-top" v-for="i in 2" :key="i">
        <div class="skeketon-center-top-left"></div>
        <div class="skeketon-center-top-right">
          <div class="item"></div>
          <div class="item"></div>
          <div class="item-three"></div>
        </div>
      </div>
      <div class="skeketon-center-bottom">
        <div class="tip">
          <p></p>
          <p></p>
        </div>
         <div class="tip-item">
          <p></p>
          <p class="width-set"></p>
        </div>
        <div class="tip">
          <p></p>
          <p></p>
        </div>
      </div>
    </div>
     <div class="skeketon-bottom">
           <div class="skeketon-bottom-item" v-for="i in 3" :key="i">
             <p></p>
             <p class="last-item"></p>
          </div>
      </div>
    </cc-main>
  </cc-container>
</template>

<script>
export default {
  components: {},

  data () {
    return {
    }
  },

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.skeketon{
  @include skeletonBlink();
  .head{
    height: 110px;
    width: 100%;
    background: var(--APP_skeleton_color);
    display: flex;
    justify-content: center;
  }
  /deep/{
   .cc-header{
    background: var(--APP_skeleton_color);
  }
  .cc-main{
   overflow: hidden !important;
    background: var(--APP_skeleton_color);
  }
  }
  &-left-content,&-center-content,&-right-content{
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: var(--APP_skeleton_color);
  }
  &-center-content{
    margin-top: 10px;
    height: 30px;
    width: 300px;
    background: #fff;
    opacity: .5;
  }
  .skeketon-top{
    width: 100%;
    height: 80px;
    background: #fff;
    border-radius: 10px;
    opacity: .6;
    padding: 15px 10px 0;
    box-sizing: border-box;
    &-top{
      width: 200px;
      height: 15px;
      border-radius: 4px;
      background: var(--APP_skeleton_color);
    }
    &-bottom{
      width: 325px;
      height: 15px;
      border-radius: 4px;
      background: var(--APP_skeleton_color);
      margin-top: 20px;
    }
  }
  .skeketon-center{
    margin-top: 10px;
    padding: 20px 10px;
    background: #fff;
    border-radius: 10px;
    opacity: .6;
    &-top{
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;
       &-left{
         height: 85px;
         width: 85px;
         border-radius: 4px;
         margin-right: 25px;
         background: var(--APP_skeleton_color);
       }
       &-right{
         .item,.item-three{
           width: 243px;
           height: 15px;
           border-radius: 2px;
           background: var(--APP_skeleton_color);
           margin-bottom: 10px;
         }
         .item-three{
           width: 136px;
           height: 15px;
         }
       }
    }
    &-bottom{
     .tip,.tip-item{
       display: flex;
       flex-direction: row;
       justify-content:space-between;
       p{
         width: 60px;
         height: 15px;
         border-radius: 2px;
         background: var(--APP_skeleton_color);
       }
     }
     .tip-item{
       margin: 20px 0;
       .width-set{
        width: 91px;
       }
     }
    }
  }
  .skeketon-bottom{
    margin-top: 10px;
    padding: 20px 10px;
    background: #fff;
    border-radius: 10px;
    opacity: .6;
    &-item{
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      p{
        width: 60px;
        height: 15px;
        border-radius: 2px;
         background: var(--APP_skeleton_color);
      }
       .last-item{
         width: 205px;
         margin-left: 25px;
       }
    }
     &-item:last-of-type{
       margin-bottom: 0;
     }
  }
}

</style>
